import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import { useLocation } from "react-router-dom";

import styles from "./PreviewPageHome.module.scss";
import UserLinkHome from "../../ui/UserLinkHome/UserLinkHome";
import { getIconLink } from "../../../services/utilites.service";
import { setStyles } from "../../../services/personalization.service";

import { useUser } from "../../../providers/user.provider";
import logo_light from "../../../assets/svg/logo-guest-white.svg";
import { Logo } from "../../icons/logo";
import { IProfileContext } from "../../../interfaces/user.context";

interface IStyle {
  preview?: boolean;
  data?: any;
  socials?: any;
  currentProfile?: IProfileContext;
}

const PreviewPageHome = ({ preview, data, socials, currentProfile }: IStyle) => {
  const user = useUser();
  const avatar =
    user.currentProfile && user.currentProfile.avatar
      ? user.currentProfile.avatar.url
      : "";

  const [showFooterLogo, setShowFooterLogo] = useState(false);
  // console.log(!user?.personalizate?.statusLogo);
  // console.log(preview);
  // console.log(data?.btn?.white, user.personalizate.btn.white);

  const mainUserData = currentProfile ? currentProfile : user.currentProfile;
  useEffect(() => {
    if (data && preview) {
      setStyles(data);
      setShowFooterLogo(!data.statusLogo);
    } else {
      setStyles(user.personalizate);
    }
  }, [user, data]);

  const location = useLocation();

  useEffect(() => {
    if (socials?.length) {
      const updatedArray = socials?.map((item: any) => {
        const updatedSocials = item.socials.map((social: any) => {
          // console.log(social);
          if (social.selected === true && social.url === "") {
            return { ...social, selected: false };
          }
          return social;
        });

        return { ...item, socials: updatedSocials };
      });

      user.setSocialTypes(updatedArray);
    }
  }, [location.pathname]);

  const activeSocials: any = [];

  // const checkActiveSocials = socials?.map((item: any, index: any) => {
  //   return item.socials.map((item: any) => {
  //     if (item.selected) {
  //       activeSocials.push(item);
  //     }
  //   });
  // });

  return (
    <div className={`main-content preview`}>
      <div
        className={
          `${styles.home} ${styles.view_home} home preview ${
            styles.home__preview
          }  ${preview ? data.themeName : user?.personalizate?.themeName} `
          //: `${styles.home} ${styles.view_home} home preview  ${profile.settings?.theme.themeName} `
        }
      >
        <div className={`${styles.container} container`}>
          <Stack
            direction="column"
            spacing={1}
            className={`${styles.avatar} align-items-center mb-5 text-center`}
          >
            <Avatar alt="User" src={avatar} className="block-center" />
            <h4 className={`name ff-gilroy fw-700`}>{mainUserData.fullName}</h4>
          </Stack>
          {user.profileInterest?.name || mainUserData?.interest?.name ? (
            <h5 className="interest fs-14 fw-400 ff-gilroy text-center mb-5">
              {mainUserData.interest
                ? mainUserData.interest.name
                : ""}
            </h5>
          ) : null}

          {(mainUserData !== null && mainUserData.location) || (mainUserData === null && user.currentProfile.location) ? (
            <p className={`location mb-15 fs-14 fw-400 ff-gilroy text-center`}>
              <svg width="14" height="17" viewBox="0 0 14 18" fill="none">
                <path d="M10.8306 11.9017L11.403 12.3048L10.8306 11.9017ZM3.16903 11.9017L2.59672 12.3048H2.59672L3.16903 11.9017ZM3.6665 12.6178L3.08623 13.0093L3.08623 13.0093L3.6665 12.6178ZM6.29298 16.0882L5.75862 16.5403L6.29298 16.0882ZM7.7067 16.0882L8.24106 16.5403L8.24106 16.5403L7.7067 16.0882ZM10.3332 12.6178L9.7529 12.2263H9.7529L10.3332 12.6178ZM12.1332 7.48652C12.1332 8.1165 11.919 8.77245 11.5623 9.46191C11.2047 10.153 10.7328 10.8249 10.2583 11.4986L11.403 12.3048C11.8673 11.6454 12.3967 10.8956 12.8057 10.1053C13.2155 9.3134 13.5332 8.42831 13.5332 7.48652H12.1332ZM6.99984 2.2C9.81791 2.2 12.1332 4.54964 12.1332 7.48652H13.5332C13.5332 3.81087 10.6251 0.8 6.99984 0.8V2.2ZM1.8665 7.48652C1.8665 4.54964 4.18177 2.2 6.99984 2.2V0.8C3.37458 0.8 0.466504 3.81087 0.466504 7.48652H1.8665ZM3.74134 11.4986C3.26685 10.8249 2.79498 10.153 2.43739 9.46191C2.08063 8.77245 1.8665 8.1165 1.8665 7.48652H0.466504C0.466504 8.42831 0.784217 9.3134 1.194 10.1053C1.60296 10.8956 2.13235 11.6454 2.59672 12.3048L3.74134 11.4986ZM4.24678 12.2263C4.08546 11.9872 3.91301 11.7424 3.74134 11.4986L2.59672 12.3048C2.77004 12.5509 2.93416 12.7839 3.08623 13.0093L4.24678 12.2263ZM6.82734 15.636C6.20653 14.9023 5.24205 13.7014 4.24678 12.2263L3.08623 13.0093C4.11725 14.5374 5.1148 15.7795 5.75862 16.5403L6.82734 15.636ZM7.17233 15.636C7.07749 15.7481 6.92219 15.7481 6.82734 15.636L5.75862 16.5403C6.41269 17.3133 7.58698 17.3133 8.24106 16.5403L7.17233 15.636ZM9.7529 12.2263C8.75763 13.7014 7.79315 14.9023 7.17233 15.636L8.24106 16.5403C8.88488 15.7795 9.88242 14.5374 10.9134 13.0093L9.7529 12.2263ZM10.2583 11.4986C10.0867 11.7424 9.91422 11.9872 9.7529 12.2263L10.9134 13.0093C11.0655 12.7839 11.2296 12.5509 11.403 12.3048L10.2583 11.4986ZM8.79984 7.48651C8.79984 8.5341 7.97696 9.35216 6.99984 9.35216V10.7522C8.78414 10.7522 10.1998 9.27286 10.1998 7.48651H8.79984ZM6.99984 5.62086C7.97696 5.62086 8.79984 6.43893 8.79984 7.48651H10.1998C10.1998 5.70016 8.78414 4.22086 6.99984 4.22086V5.62086ZM5.19984 7.48651C5.19984 6.43893 6.02272 5.62086 6.99984 5.62086V4.22086C5.21553 4.22086 3.79984 5.70016 3.79984 7.48651H5.19984ZM6.99984 9.35216C6.02272 9.35216 5.19984 8.5341 5.19984 7.48651H3.79984C3.79984 9.27286 5.21553 10.7522 6.99984 10.7522V9.35216Z" />
              </svg>
              {mainUserData !== null ? mainUserData.location : user.currentProfile.location}
            </p>
          ) : null}

          <div
            className={
              "social-platforms-links social-platforms-links_preview-window flex-wrap"
            }
          >
            {socials ? (
              <>
                {socials.map((item: any, index: any) => {
                  return item.selected ? (
                    <a
                      className={`social-platforms-links__item flex-center-center social_icon_home`}
                      href={
                        item.name === "Email" ? `mailto:${item.url}` : item.url
                      }
                      key={index}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={getIconLink(item.name)} alt={item.name} />
                    </a>
                  ) : null;
                })}
              </>
            ) : (
              <>
                {user?.userSocials?.map((item, index) => {
                  return item.selected ? (
                    <a
                      className={`social-platforms-links__item flex-center-center social_icon_home`}
                      href={
                        item.name === "Email" ? `mailto:${item.url}` : item.url
                      }
                      key={index}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={getIconLink(item.name)} alt={item.name} />
                    </a>
                  ) : null;
                })}{" "}
              </>
            )}
          </div>
          <div className={`${styles.home_cards} home_cards`}>
            {user?.profileLinks.map((item, index) => {
              return item.visible ? (
                <UserLinkHome
                  preview={user?.previewImage?.find((el: any) =>
                    el.id === item.id ? el.url : ""
                  )}
                  link={item}
                  role={""}
                  key={"user_link_" + index}
                  index={index}
                  onReorder={() => {}}
                  onVisible={() => {}}
                  onDelete={() => {}}
                />
              ) : null;
            })}
          </div>

          {(!preview && !user?.personalizate?.statusLogo) || (preview && showFooterLogo) ? (
            <>
              {user.personalizate.btn.white ? (
                <img
                  className={"logoHome logoHome_rightBar   mb-10"}
                  src={logo_light}
                  alt="the only link logo"
                />
              ) : (
                <Logo.mainLogo className={"logoHome_rightBar  mb-10"} />
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PreviewPageHome;
